function App() {
  return (
    <div className="flex h-screen flex-col">
      <img
        src="assets/r24.png"
        alt="icon"
        className="w-64 h-64 mx-auto mt-8"
      />

      <div className="text-center text-4xl font-extrabold mt-4">R24</div>

      <div className="text-center mt-4 text-xl">
        Hebrew podcasts for learning on the go:
      </div>

      <div className="text-center mt-2">
      the Torah portion, the Psalms, Tanya, Rambam, the Rebbe’s talks 
        <br />
        and other audio books for your daily study. 
      </div>

      <div className="text-center mt-4 flex flex-col self-center">
        <a
          className="flex-1"
          href="https://play.google.com/store/apps/details?id=com.rabbi24.r24daily"
        >
          <img
            className="w-52 md:w-40 rounded-xl"
            alt="Get it on Google Play"
            src="assets/google-play-badge.svg"
          />
        </a>

        <a
          className="flex-1 mt-2"
          href="https://apps.apple.com/us/app/r24/id1564068630?itsct=apps_box_badge&amp;itscg=30200"
        >
          <img
            className="w-52 md:w-40 rounded-xl"
            src="assets/appstore-badge-black.svg"
            alt="Download on the App Store"
          />
        </a>
      </div>
    </div>
  );
}

export default App;
